<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5 class="inline">
          <span v-if="request.deleted=='0'">Запросы клиентов на получение информации о поступлении препарата</span>
          <span v-else>Корзина</span>
        </h5>
        <ul class="nav nav-tabs card-header-tabs">
          <li class="nav-item" v-for="site in sites">
            <a class="nav-link" :class="request.site_id==site.id?'active':''" :href="'#'+site.id" @click="getItems({site_id: site.id})">
              {{ site.name }}
              <span class="badge badge-secondary" v-if="site.qty">{{ site.qty }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="card-body" v-if="sites.length">
        <table class="table">
          <thead class="thead-dark">
          <tr>
            <th>ID</th>
            <th>Препарат</th>
            <th>Имя</th>
            <th>Email</th>
            <th>Телефон</th>
            <th width="210">Статус</th>
            <th width="130">Время</th>
            <th width="170">Действия</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item, index in items" :key="item.id" :class="item.status=='called'?'called':''">
            <th>{{ item.id }}</th>
            <td>
              <a v-if="item.product" :href="item.product.url">{{ item.product.name }}</a>
            </td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>
              <div v-if="item.phone&&item.phone!='не указан'">
                <MakeCall :phone="{phone:item.phone.replace(/[^0-9]/g, '')}" :order="{id:0,client_id:0,site_id:request.site_id,city_id:0}">
                  <slot name="btn">
                    <button type="button" class="btn btn-success btn-xs call_btn">
                      {{ item.phone }}
                    </button>
                  </slot>
                </MakeCall>
              </div>
              <span v-else>не указан</span>
            </td>
            <td>
              <select class="form-control form-control-sm" v-model="item.status">
                <option value="">Ждет уведомления</option>
                <option value="called">Информирован</option>
                <option value="not_called">Не дозвонились</option>
              </select>
            </td>
            <td>{{ item.created_at }}</td>
            <td>
              <div v-if="loaded">
                <div v-if="request.deleted=='0'">
                  <button type="button" class="btn btn-xs btn-danger" style="margin:0 5px" title="В корзину" @click="removeItem(item.id, index)">
                    <i class="icon-fa icon-fa-trash-o" aria-hidden="true"></i>
                  </button>
                  <button type="button" class="btn btn-xs btn-success" title="Сохранить" @click="updateItem(item, index)">
                    <i class="icon-fa icon-fa-save" aria-hidden="true"></i>
                  </button>
                </div>
                <div v-else>
                  <button type="button" class="btn btn-xs btn-success" title="Сохранить" @click="restoreItem(item.id, index)">
                    Восстановить
                  </button>
                  <button type="button" class="btn btn-xs btn-danger" style="margin:0 5px" title="Удалить безвозвратно" @click="destroyItem(item.id, index)">
                    <i class="icon-fa icon-fa-trash-o" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-if="loaded">
          <div v-if="request.deleted=='0'" class="">
            <button type="button" class="btn btn-info" @click="getItems({ site_id: request.site_id, deleted: '1' })">Запросы в корзине</button>
          </div>
          <div v-else class="">
            <button type="button" class="btn btn-info" @click="getItems({ site_id: request.site_id, deleted: '0' })">Выйти из корзины</button>
          </div>
        </div>
      </div>
      <div class="card-body" v-else>
        <p v-if="loaded">У вас нет разрешенных сайтов для просмотра</p>  
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import MakeCall from "@/components/orders/telephony/MakeCall"

export default {
  components: {
    MakeCall
  },
  data() {
    return {
      items: [],
      sites: [],
      request: {
        type: 'available',
        site_id: 1,
        deleted: 0
      },
      token: '',
      loaded: true,
      basket: '0'
    }
  },
  mounted() {
    this.token = 'Bearer ' + localStorage.getItem('auth.token');
    this.getItems();
  },
  computed: {
    customRequestsCount() {
      return this.$store.getters["customRequests/count"];
    }
  },
  methods: {
    async getItems(options) {
      this.loaded = false
      if (options) {
        if (options.site_id) this.request.site_id = options.site_id;
        if (options.deleted) {
          this.request.deleted = options.deleted;
          this.basket = options.deleted;
        } else {
          this.request.deleted = this.basket;
        }
      }
      await axios
        .post('/api/customRequests/get', this.request)
        .then(resp => {
          this.items = resp.data.items;
          this.sites = resp.data.sites;
          this.request.site_id = resp.data.site_id;
          this.loaded = true;
          this.$store.dispatch('customRequests/getCount');
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async updateItem(item, index) {
      let url = '/api/customRequests/update';
      let response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': this.token
        },
      });
      let result = await response.json();
      toastr['success']('Запрос сохранен!', 'Успешно')
    },
    async removeItem(id, index) {
      let app = this;
      if (confirm("Вы действительно готовы отправить запрос в корзину?")) {
        let url = '/api/customRequests/remove/' + id;
        let response = await fetch(url, {
          method: 'DELETE',
          headers: {
            'Authorization': this.token
          },
        });
        let result = await response.json();
        toastr['success']('Запрос отправлен в корзину!', 'Успешно');
        this.getItems();
      }
    },
    async destroyItem(id, index) {
      if (confirm("Вы готовы безвозвратно удалить запрос?")) {
        let url = '/api/customRequests/destroy/' + id;
        let response = await fetch(url, {
          method: 'DELETE',
          headers: {
            'Authorization': this.token
          },
        });
        let result = await response.json();
        toastr['success']('Запрос безвозвратно удален!', 'Успешно');
        this.getItems();
      }
    },
    async restoreItem(id, index) {
      if (confirm("Вы уверены?")) {
        let url = '/api/customRequests/restore/' + id;
        let response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': this.token
          },
        });
        let result = await response.json();
        toastr['success']('Запрос возращен из корзины!', 'Успешно');
        this.getItems();
      }
    }
  }
}
</script>
<style scoped>
.table .thead-dark th {
  background-color: #343a52;
}

.btn i {
  width: auto;
}

.card .card-header h5 {
  margin-bottom: 20px;
}

.card .card-header h5 {
  margin-bottom: 20px;
}

tr {
  background-color: #f49dea69;
}

tr.called {
  background-color: #39f88769;
}
</style>
